import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import UserEmailVerification from '../../Settings/Users/UserEmailVerification/UserEmailVerification';
import UserForm from '../../Settings/Users/UserForm/UserForm';

function UserModal(props) {
	const { show, onClose, callback, users } = props;
	const [emailVerification, setEmailVerification] = useState(!props.user.userID);
	const [email, setEmail] = useState('');
	const { t } = useTranslation();

	const handleCallback = () => {
		onClose();
		callback();
	};

	return (
		<Modal
			show={show}
			onHide={handleCallback}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">
					{props.user.userID ? t('general.person_details') : t('general.create_new_user')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{emailVerification ?
					<UserEmailVerification
						users={users}
						email={email}
						setEmail={setEmail}
						setEmailVerification={setEmailVerification}
					/>
				:
					<UserForm
						user={{
							...props.user,
							email: props.user.email || email
						}}
						callback={handleCallback}
					/>
				}
			</Modal.Body>
			<Modal.Footer>
				<Button
					type="button"
					variant="default"
					onClick={handleCallback}
				>
					{t('general.close')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default UserModal;